import React, { ReactElement } from "react";
import { FieldError, FieldErrorsImpl, Merge } from "react-hook-form";
import { FormattedMessage } from "@/i18n/i18n-client";

export interface FormFieldProps {
  label?: React.ReactNode;
  error?: FieldError | Merge<FieldError, FieldErrorsImpl<any>>;
  children: ReactElement;
  isOptional?: boolean;
  className?: string;
  id?: string;
  showStrick?: boolean;
}

const FormField = ({
  label,
  error,
  children,
  isOptional,
  className,
  id,
  showStrick = true,
}: FormFieldProps) => {
  return (
    <div className={`flex flex-col gap-3xs ${className}`}>
      <div className="flex flex-col gap-2xs">
        {label && (
          <div className="flex items-center gap-4xs">
            <label className="field-label" htmlFor={id}>
              {label}
            </label>
            {isOptional ? (
              <span className="text-text-sm text-gray-400 ">
                <FormattedMessage defaultMessage="(Optional)" id="nA4XGc" />
              </span>
            ) : (
              showStrick && <span className="text-text-sm text-red-500">*</span>
            )}
          </div>
        )}
        {React.cloneElement(children, { id })}
      </div>
      {error && (
        <span className="field-error">{error?.message?.toString()}</span>
      )}
    </div>
  );
};

export default FormField;
